import { render, staticRenderFns } from "./DeletedPrompt.vue?vue&type=template&id=6cc7978d&"
import script from "./DeletedPrompt.vue?vue&type=script&lang=js&"
export * from "./DeletedPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports